import Component from 'vue-class-component';
import BasketListAbstract from '../BasketAbstract/BasketListAbstract';
import BasketElementRow from './BasketElementRow';

@Component({
    components: {
        BasketElementRow
    }
})
export default class BasketTable extends BasketListAbstract {
    pagination = {
        sortBy: null as string | null,
        descending: false,
        rowsPerPage: -1,
        page: 1
    }

    // по возрастанию → по убыванию → исходный порядок корзины
    changeSort(column: string) {
        if (this.pagination.sortBy !== column) {
            this.pagination.sortBy = column
            this.pagination.descending = false
        } else if (!this.pagination.descending) {
            this.pagination.descending = true
        } else {
            this.pagination.sortBy = null
            this.pagination.descending = false
        }
    }

    sortProducts(items: any[], sortBy: string | null, descending: boolean) {
        if (!sortBy) return items
        // Учетная — отформатированная строка ("1 234,50"), сортируем по числу
        const key = sortBy === 'Учетная' ? 'original_price' : sortBy
        const compare = (a: any, b: any) => {
            const valA = a[key]
            const valB = b[key]
            // цена из price_matrix может прийти строкой ("12.5") — сравниваем как число
            if (key === 'original_price') return (+valA || 0) - (+valB || 0)
            if (typeof valA === 'number' && typeof valB === 'number') return valA - valB
            return String(valA == null ? '' : valA).localeCompare(String(valB == null ? '' : valB), 'ru', { numeric: true })
        }
        return items.slice().sort((a, b) => descending ? compare(b, a) : compare(a, b))
    }
}
